import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';
import {useCheckAuth} from '@features/auth/authHook';
import {LoaderFullScreen} from '@features/ui/components/LoaderFullScreen';

export const Route = createFileRoute('/changelog')({component: ChangelogPage});

function ChangelogPage() {
  const navigate = useNavigate();
  const {isAuth, isAuthLoading} = useCheckAuth();

  useEffect(() => {
    if (isAuthLoading) return;
    if (isAuth) {
      void navigate({to: '/whats-new', replace: true});
    } else {
      window.location.href = 'https://www.banani.co/changelog';
    }
  }, [isAuth, isAuthLoading, navigate]);

  return <LoaderFullScreen />;
}
